import React, { Dispatch, SetStateAction } from 'react';
import { styled } from '@mui/material/styles';
import { Switch, Stack, Typography, SxProps, InputLabel } from '@mui/material';
import logger from 'app/utils/logger';
import { red2 } from 'app/components/ThemeProvider/colors';

interface Props {
  title: string;
  checked?: boolean;
  sx?: SxProps;
  handleToggle?: (flag: boolean) => void;
  handleToggleArr?: (flag: any) => void;
  rest?: any;
  index?: any;
  color?: string;
}

const AntSwitch = styled(Switch)(({ theme, color }) => ({
  width: 34,
  height: 18,
  padding: 0,
  display: 'flex',
  borderRadius: '20px',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 16,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(16px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 1,
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : color === 'secondary' ? red2 : '#24B07E',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 16,
    height: 16,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

const CustomSwitch = (props: Props) => {
  const { title, sx, checked, handleToggle, rest, index, handleToggleArr, color } = props;

  logger.log('index');
  logger.log(checked);

  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={sx}>
      <InputLabel
        sx={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          alignItems: 'center',

          '&:hover': { cursor: 'pointer' },
        }}
      >
        <AntSwitch
          inputProps={{ 'aria-label': 'ant design' }}
          checked={checked}
          color={color}
          onClick={() => {
            if (index !== undefined) {
              handleToggleArr(index);
            } else {
              if (checked !== undefined) {
                handleToggle(!checked);
              }
            }
          }}
          {...rest}
        />
        <Typography>{title}</Typography>
      </InputLabel>
    </Stack>
  );
};

export default CustomSwitch;
